<template>
  <div>
    <CRow>
      <CCol sm="6" md="4">
        <CCard>
          <CCardHeader>
            <strong>{{ course.title }}</strong>
          </CCardHeader>
          <CCardBody>
              <img v-bind:src="course.thumbnail" alt="" width="100%">
            {{ course.description }}
          </CCardBody>
          <CCardFooter>
            <CButton color="danger" @click="() => $router.push('/course')">
                  Regresar
              </CButton>
              <CButton class="float-right" color="primary" @click="() => $router.push('/course/' + course.id + '/lessons')">
                  Empezar
              </CButton>
          </CCardFooter>
        </CCard>

        <CCard v-if="course.attempt">
          <CCardHeader>
            Evaluación
          </CCardHeader>
          <CCardBody>
            {{ course.attempt.score }} / {{ course.quiz.questions.length}}  = {{ course.attempt.percentage }}% | Min. {{ course.quiz.min_score }}<br>
              <div v-if="course.attempt.percentage >= course.quiz.min_score" class='text-success'>
                APROBADO
              </div>
              <div v-if="course.attempt.percentage < course.quiz.min_score" class='text-danger'>
                REPROBADO
              </div>
          </CCardBody>
        </CCard>


      </CCol>
      <CCol sm="6" md="8">
        <CCard v-if="lessons">
          <CCardHeader>
            <Strong>Lecciones</Strong>
          </CCardHeader>
          <CCardBody>
            <div class="progress mb-4">
              <div class="progress-bar" role="progressbar" v-bind:style="getProgress()" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <ul>
              <li v-for="lesson in lessons" :key="lesson.id">
                {{ lesson.title }}
              </li>
            </ul>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
export default {
  name: 'Course',
  data: function () {
    return {
        course: {},
        lessons: [],
      show: true,
      isCollapsed: true,
      loremIpsum: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.'
    }
  },
  mounted() {
      const token = store.state.user.token;
      axios
        .get(process.env.VUE_APP_BACKEND_URL+'/api/course/' + this.$route.params.id, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            this.course = response.data.data;
        })

      axios
        .get(process.env.VUE_APP_BACKEND_URL+'/api/course/' + this.$route.params.id + '/lessons', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            this.lessons = response.data.data;
        })
  },
  methods: {
    getProgress() {
      if (this.course.course_user) {
        let width = this.course.course_user.completed / this.course.course_user.total * 100;
        return {'width': width + '%'}
      }
      return {'width': '0'}
    }
  }
}
</script>
